import { MapColorTheme, MapColorSlotDefinition } from "@app/shared/map-appearance/interfaces";
import {
  COUNTY_SHADING_MAX_AMETHYST_THEME,
  COUNTY_SHADING_MIN_AMETHYST_THEME,
  COUNTY_SHADING_MAX_AZURE_THEME,
  COUNTY_SHADING_MIN_AZURE_THEME,
  COUNTY_SHADING_MAX_JADE_THEME,
  COUNTY_SHADING_MIN_JADE_THEME,
} from "@app/overviews/market-expansion-dashboard/MarketExpansionDashboardConstants";

export const MEMBERSHIP_COLOR_SLOT_DEFINITIONS: MapColorSlotDefinition[] = [
  { key: "minMetricColor", label: "Minimum Value" },
  { key: "maxMetricColor", label: "Maximum Value" },
];

export const MEMBERSHIP_COLOR_THEME_AMETHYST: MapColorTheme = {
  colors: {
    maxMetricColor: COUNTY_SHADING_MAX_AMETHYST_THEME,
    minMetricColor: COUNTY_SHADING_MIN_AMETHYST_THEME,
  },
  name: "Amethyst",
  uuid: "membership-amethyst",
};

const MEMBERSHIP_COLOR_THEME_AZURE: MapColorTheme = {
  colors: {
    maxMetricColor: COUNTY_SHADING_MAX_AZURE_THEME,
    minMetricColor: COUNTY_SHADING_MIN_AZURE_THEME,
  },
  name: "Azure",
  uuid: "membership-azure",
};

const MEMBERSHIP_COLOR_THEME_JADE: MapColorTheme = {
  colors: {
    maxMetricColor: COUNTY_SHADING_MAX_JADE_THEME,
    minMetricColor: COUNTY_SHADING_MIN_JADE_THEME,
  },
  name: "Jade",
  uuid: "membership-jade",
};

export const MEMBERSHIP_PRESET_THEMES: MapColorTheme[] = [
  MEMBERSHIP_COLOR_THEME_AMETHYST,
  MEMBERSHIP_COLOR_THEME_AZURE,
  MEMBERSHIP_COLOR_THEME_JADE,
];
